/*global module:true*/

module.exports = {
  instrumentGroups: [
    { label: "Stock Lists", id: "stock-lists",
      data: [
        { label: "S&P 100" },
        { label: "Dow 30" },
        { label: "NASDAQ 100" },
        { label: "Consumer Discretionary" },
        { label: "Consumer Staples" },
        { label: "Energy" },
        { label: "Financials" },
        { label: "Health" },
        { label: "Industrials" },
        { label: "Information Technology" },
        { label: "Materials" },
        { label: "Telecom" },
        { label: "Utilities" }
      ] },
    { label: "NYSE / NASDAQ MARKETS", id: "nyse-nasdaq",
      data: [
        { label: "NYSE Net Gainers" },
        { label: "NYSE Percent Gainers" },
        { label: "NYSE Net Losers" },
        { label: "NYSE Percent Losers" },
        { label: "NYSE Most Actives" },
        { label: "NASDAQ Net Gainers" },
        { label: "NASDAQ Percent Gainers" },
        { label: "NASDAQ Net Losers" },
        { label: "NASDAQ Percent Losers" },
        { label: "NASDAQ Most Actives" }
      ] },
    { label: "ETFs", id: "etfs",
      data: [
        { label: "SPDR S&P 500 (SPY)" },
        { label: "iShares Russell 2000 ETF (IWM)" },
        { label: "PowerShares QQQ (QQQ)" },
        { label: "iShares MSCI Emerging Markets (EEM)" },
        { label: "iShares MSCI EAFE ETF (EFA)" },
        { label: "SPDR Gold Shares (GLD)" },
        { label: "iShares 20 Year Treasury (TLT)" },
        { label: "iShares iBoxx High Yield (HYG)" },
        { label: "Financial Sector SPDR (XLF)" },
        { label: "Energy Sector SPDR (XLE)" },
        { label: "Industrial Sector SPDR (XLI)" },
        { label: "Utilities Sector SPDR (XLU)" }
      ] },
    { label: "US Indexes", id: "us-indexes", isPremium: true,
      data: [
        { label: "Dow Jones Industrial Average" },
        { label: "Dow Jones Transportation Average" },
        { label: "Dow Jones Utility Average" },
        { label: "S&P 100 Index" },
        { label: "S&P 500 Index" },
        { label: "NASDAQ Composite" },
        { label: "CBOE Volatility Index" }
      ] },
    { label: "World Indexes", id: "world-indexes", isPremium: true,
      data: [
        { label: "S&P / TSX60 Index" },
        { label: "BOVESPA Index" },
        { label: "HANG SENG Index" },
        { label: "Shanghai Composite Index" },
        { label: "NIKKEI 225 Index" },
        { label: "Straits Times Index" },
        { label: "KOSPI Index" },
        { label: "SET Composite Index" },
        { label: "All Ordinaries Index" },
        { label: "EURO Stoxx 50 Index" },
        { label: "DAX Index" },
        { label: "CAC 40 Index" }
      ] },
    { label: "Bonds", id: "bonds", isPremium: true },
    { label: "Currencies", id: "currencies", isPremium: true },
    { label: "Energy", id: "energy", isPremium: true },
    { label: "Metals", id: "metals", isPremium: true },
    { label: "Agriculture", id: "agriculture", isPremium: true },
  ],
};
